import React, { useEffect, useState } from "react";
import { ChevronDown, Flag } from "lucide-react";
import RegionEuLogos from "../RegionEuLogos";
import EuropaLegalFooter from "../legal/EuropaLegalFooter";

/** Loghi Abruzzo / UE e nota legale — chiusi di default, tendina Apri/Chiudi. */
export default function FooterSezionePartner() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open]);

  return (
    <div className="border-t border-borderline bg-parchment2/30" data-testid="footer-sezione-partner">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        aria-controls="footer-sezione-partner-panel"
        className="w-full max-w-[1400px] mx-auto px-5 md:px-10 py-4 flex items-center justify-between gap-4 text-left hover:bg-parchment2/50 transition-colors"
        data-testid="footer-sezione-partner-toggle"
      >
        <div className="min-w-0">
          <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-terracotta mb-1 inline-flex items-center gap-2">
            <Flag size={11} aria-hidden />
            Partner istituzionali
          </p>
          <p className="font-display text-lg sm:text-xl text-ink leading-snug">
            Abruzzo · <span className="text-terracotta">Unione Europea</span>
            <span className="hidden sm:inline text-ink2 font-sans text-sm font-normal">
              {" "}
              — loghi e nota legale
            </span>
          </p>
        </div>
        <span
          className={`shrink-0 flex items-center gap-1.5 text-xs font-mono uppercase tracking-wider text-ink2 ${
            open ? "text-terracotta" : ""
          }`}
        >
          {open ? "Chiudi" : "Apri"}
          <ChevronDown
            size={18}
            className={`transition-transform duration-200 ${open ? "rotate-180" : ""}`}
            aria-hidden
          />
        </span>
      </button>

      {open && (
        <div
          id="footer-sezione-partner-panel"
          className="border-t border-borderline/80"
          data-testid="footer-sezione-partner-panel"
        >
          <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-6 flex flex-col sm:flex-row items-center sm:items-start gap-5">
            <RegionEuLogos
              className="gap-4 sm:gap-5 justify-center sm:justify-start"
              abruzzoClassName="w-24 md:w-28"
              euClassName="w-12 md:w-14"
              testIdPrefix="footer"
            />
            <EuropaLegalFooter className="max-w-md text-center sm:text-left" align="left" />
          </div>
        </div>
      )}
    </div>
  );
}
